import {
  isStreamAddressStep,
  streamAddressProblems,
} from "../onBoardingWizardFieldTypes/streamAddress";
import { isFieldVisible } from "../../utils/fieldVisibility";

export const handleCheckForRequriedFields = (
  formikValues: any,
  responseObject: any,
  setNextOrSubmitButtonDisabled: any
) => {
  let allRequiredFieldsFilled = true;

  responseObject.forEach((step: any) => {
    // A field hidden by its visible_when rule (ENG-2535) cannot be filled
    // in, so it never blocks the step.
    if (step.validation && isFieldVisible(step.visible_when, formikValues)) {
      if (
        formikValues[step.field] === "" ||
        formikValues[step.field] === undefined ||
        formikValues[step.field] === null ||
        //or if it is an array and the length is 0
        (Array.isArray(formikValues[step.field]) &&
          formikValues[step.field].length === 0)
      ) {
        allRequiredFieldsFilled = false;
      }
    }
  });

  // ENG-1924: a Host or Stream Parameter the connector cannot dial (e.g. a
  // whole rtsps:// URL in Stream Parameter) blocks the step like a missing
  // required field; StreamUrlAssist shows why.
  if (
    isStreamAddressStep(responseObject) &&
    Object.keys(streamAddressProblems(formikValues)).length > 0
  ) {
    allRequiredFieldsFilled = false;
  }

  setNextOrSubmitButtonDisabled(!allRequiredFieldsFilled);
};
